import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
    getManualKycReqSuccess,
    getManualKycReqError
} from './manualKycActions';
import { GET_MANUAL_KYC_REQ } from "../actionType";
import { MANUAL_KYC_API } from '../../../utils/urls';
import { fetchPost } from '../../../utils/request';

const stateValue = (state: any) => state.manualKyc;

function* manualKycAuth(): any {
    const stateName = yield select(stateValue);
    let body = {
        image: stateName?.manualKycImage,
        pancardValue: stateName?.manualKycValue?.pancardNo,
    }
    try {
        // const response = yield call(fetchPost, MANUAL_KYC_API, body);
        const response :any = {
        //     // status: true,data:"data successfully",
            status: false,error:"No Data Found"
        }
        if (response.error) {
            yield put(getManualKycReqError(response));
            return false;
        }
        yield put(getManualKycReqSuccess(response));
        return true;
    } catch (error) {
        yield put(getManualKycReqError(error));
    }
}

export default function* legalSaga() {
    yield all([takeLatest(GET_MANUAL_KYC_REQ, manualKycAuth)])
}